export { TabHeader } from "./component";
export type { TabHeaderProps, TabHeaderStyleProps } from "./types";
